import React, { useState } from 'react';
import Slider from 'react-slick';
import testimonialsData from './catering-testimonials.json';
import classnames from 'classnames';

export const CateringTestimonialsSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  return (
    <section className="catering-testimonials-section">
      <div className="catering-testimonial-cards-wrap">
        <Slider
          infinite={true}
          slidesToShow={3}
          swipeToSlide={true}
          autoplay={true}
          dots={true}
          pauseOnHover={false}
          dotsClass="slick-dots catering-testimonial-dots"
          beforeChange={(_, next) => {
            setActiveSlide(next);
          }}
          customPaging={(i) => (
            <button
              className={classnames('catering-testimonial-dot', {
                'catering-testimonial-dot-active': i === activeSlide
              })}
              onClick={() => setActiveSlide(i)}
            />
          )}
          responsive={[
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]}
        >
          {testimonialsData.map((testimonial, i) => (
            <div
              key={testimonial.name}
              className={`catering-testimonial-card-wrap-${i + 1}`}
            >
              <div key={testimonial.name} className="catering-testimonial-card">
                <p className="tw-body-2">{testimonial.testimonial}</p>

                <div className="catering-testimonial-author-wrap">
                  <img
                    className="catering-testimonial-avatar"
                    src={testimonial.avatar}
                    alt={testimonial.name}
                  />
                  <span className="tw-body-2-m">{testimonial.author}</span>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};
